import axios from "./orderInstance"
export default async (orderId: string) => {
  try {
    const response: any = await axios.get(`/orders/${orderId}/image-service/result`)
    return response.data
  } catch (error) {
    return null
  }
}
